/* tslint:disable */
require('./image-gallery-no-icon.module.css');
const styles = {
  'image-gallery': 'image-gallery_93275d79',
  'fullscreen-modal': 'fullscreen-modal_93275d79',
  'image-gallery-content': 'image-gallery-content_93275d79',
  fullscreen: 'fullscreen_93275d79',
  'image-gallery-slide': 'image-gallery-slide_93275d79',
  'image-gallery-slide-wrapper': 'image-gallery-slide-wrapper_93275d79',
  left: 'left_93275d79',
  right: 'right_93275d79',
  'image-gallery-fullscreen-button': 'image-gallery-fullscreen-button_93275d79',
  'image-gallery-play-button': 'image-gallery-play-button_93275d79',
  'image-gallery-left-nav': 'image-gallery-left-nav_93275d79',
  'image-gallery-right-nav': 'image-gallery-right-nav_93275d79',
  'image-gallery-slides': 'image-gallery-slides_93275d79',
  center: 'center_93275d79',
  'image-gallery-description': 'image-gallery-description_93275d79',
  'image-gallery-bullets': 'image-gallery-bullets_93275d79',
  'image-gallery-bullets-container': 'image-gallery-bullets-container_93275d79',
  'image-gallery-bullet': 'image-gallery-bullet_93275d79',
  active: 'active_93275d79',
  'image-gallery-thumbnails-wrapper': 'image-gallery-thumbnails-wrapper_93275d79',
  'image-gallery-thumbnails': 'image-gallery-thumbnails_93275d79',
  'image-gallery-thumbnail': 'image-gallery-thumbnail_93275d79',
  'image-gallery-thumbnails-container': 'image-gallery-thumbnails-container_93275d79',
  'image-gallery-thumbnail-label': 'image-gallery-thumbnail-label_93275d79',
  'image-gallery-index': 'image-gallery-index_93275d79',
};

export default styles;
/* tslint:enable */